import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ebb845b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3ebb845b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebb845b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ebb845b')) {
      api.createRecord('3ebb845b', component.options)
    } else {
      api.reload('3ebb845b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3ebb845b&scoped=true", function () {
      api.rerender('3ebb845b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/sailing-version/index.vue"
export default component.exports